import { BrowserRouter, Route, Routes } from "react-router-dom"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DemoModal from "./components/DemoModal";

import Home from "./pages/Home";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import DeploymentConfiguration from "./pages/DeploymentConfiguration";
import DataCleaningMigration from "./pages/DataCleaningMigration";
import OurProductVetri from "./pages/OurProductVetri";
import StaffTrainingOnboarding from "./pages/StaffTrainingOnboarding";
import APIIntegrationAutomation from "./pages/APIIntegrationAutomation";
import MaintenanceTechnicalSupport from "./pages/MaintenanceTechnicalSupport";
import DataManagementOptimization from "./pages/DataManagementOptimization";
import HiringPayrollHROperations from "./pages/HiringPayrollHROperations";

const App = () => {
  return (
    <BrowserRouter>
    <DemoModal />
      <ToastContainer position='top-center' pauseOnHover={false} />
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/about-us" element={<About/>} />
        <Route path="/contact-us" element={<ContactUs/>} />
        <Route path="/deployment-configuration" element={<DeploymentConfiguration/>} />
        <Route path="/data-cleaning-migration" element={<DataCleaningMigration/>} />
        <Route path="/our-product-vetri" element={<OurProductVetri/>} />
        <Route path="/staff-training-onboarding" element={<StaffTrainingOnboarding/>} />
        <Route path="/api-integration-automation" element={<APIIntegrationAutomation/>} />
        <Route path="/maintenance-support" element={<MaintenanceTechnicalSupport/>} />
        <Route path="/data-management" element={<DataManagementOptimization/>} />
        <Route path="/hiring-payrolls" element={<HiringPayrollHROperations/>} />


      </Routes>
    </BrowserRouter>
  )
}

export default App